import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Credentials, CredentialsService} from "@core/authentication/credentials.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BackendService} from "@core/backendService/backend.service";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Survey} from "@shared/models/Survey";
import {FacebookPixelService} from "@app/feature/facebook/facebook-pixel/facebook-pixel.service";
import {Observable, Subject, Subscription} from "rxjs";
import {map, shareReplay, switchMap, switchMapTo} from "rxjs/operators";
import {Configuration} from "@shared/models/Configuration";
import {IframeStatus, MessageEventData} from "@pages/user/user-survey/user-survey.types";
import {HttpErrorResponse} from "@angular/common/http";


@Component({
  selector: 'app-user-survey',
  templateUrl: './user-survey.component.html',
  styles: [`
    iframe{
      width: 100%;
      //min-height: 100%;
    }
  `]
})
export class UserSurveyComponent implements OnInit, OnDestroy {
  constructor(
      private readonly credentialsService: CredentialsService,
      private readonly route: ActivatedRoute,
      private readonly backendService: BackendService,
      private readonly domSanitizer: DomSanitizer,
      private readonly router:Router,
      private readonly facebookPixelService: FacebookPixelService
  ) {}

  @ViewChild('surveyFrame', {read: ElementRef}) surveyFrame:ElementRef<HTMLIFrameElement>

  public participantID$: Observable<number> = this.credentialsService.change$.pipe(
    map((credentials: Credentials) => credentials.participant_id),
    shareReplay(1)
  )
  private readonly surveyCompleted$: Subject<void> = new Subject<void>()
  private readonly refresh$ : Observable<Survey> = this.surveyCompleted$.pipe(
    switchMapTo(this.participantID$),
    switchMap((participantID: number)=>this.backendService.update_participant_survey(participantID, this.surveyID))
  )

  public limeSurveyUrl$: Observable<string> = this.backendService.config$.pipe(
    map((configuration: Configuration) => configuration.limesurveyUrl),
    shareReplay(1)
  )

  public surveyLink$: Observable<SafeResourceUrl> = this.limeSurveyUrl$.pipe(
    map((limesurveyUrl: string) => this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${limesurveyUrl}/index.php/${this.surveyID}?token=${ this.surveyToken }`
    )),
    shareReplay(1)
  )

  private readonly subscriptions: Subscription[] = []

  public surveyToken:string
  public surveyID:string
  public iframeStatus: IframeStatus = new IframeStatus()
  private registration_flag: boolean = false


  @HostListener('window:message', ['$event'])
  onMessage(event:MessageEvent<MessageEventData>) {
    let type = event.data.type
    let message = event.data.message
    console.log('Message received', event)

    // Avoid receiving new events after survey close
    // if(this.iframeStatus?.status === 'closing' || this.iframeStatus?.status === 'completed'){ return }
    // Handle survey click on 'return back' link
    if(type === 'surveyclose'){
      console.log('Survey closed', this.iframeStatus)
      this.iframeStatus?.status === 'errored'
        ? console.log('Survey closed with errors', this.iframeStatus)
        : this.iframeStatus.merge({status: 'closing'})
      ;

      // Redirect user to dashboard
      this.router.navigate(['/'])
    }

    // Handle survey completed
    if(type === 'surveycompleted'){
      if(!this.registration_flag){
        this.iframeStatus.merge({status: 'completed'})
        this.registration_flag = true;
        // Check if this user registration took place after the user has landed on the platform from facebook AD link
        // IF true send a pixel to facebook to notify the conversion
        if(!!this.credentialsService.credentials && !!this.credentialsService.credentials.facebook_pixel_click_id){
          this.facebookPixelService.pixelInitialize()
          this.facebookPixelService.userRegistered()
          this.facebookPixelService.removeFacebookPixelClickID()
        }
      }
      this.surveyCompleted$.next()
    }

    if(type === 'pagechange'){
      window.scroll(0, 0)
      this.iframeStatus.merge(message)
    }
    if(type === 'surveyerror'){
      this.iframeStatus.merge({status: 'errored'})
    }
    if(type === 'statuschange' || type === 'resize'){
      this.iframeStatus.merge(message)
    }
    if(type === 'scroll'){
      let top = event.data.scroll.y
      if(event.data.scroll.height) {
        let elementHeight = event.data.scroll.height
        let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        top = top - ((vh - elementHeight) / 2)
      }
      window.scroll(event.data.scroll.x, top)
    }
  }

  ngOnInit(): void {
    this.surveyID = this.route.snapshot.paramMap.get("id")
    this.surveyToken = this.route.snapshot.queryParamMap.get('token')

    const refreshSubscription$ = this.refresh$.subscribe((
        (surveys: Survey)=>{ console.log(`Survey Completed successfully`) } ),
        (error:HttpErrorResponse) =>{ console.log('Survey Completed with errors', error)}
    )
    this.subscriptions.push(refreshSubscription$)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe())
  }
}
